var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ChildrensAdventurers'),_c('ChildrensVBS'),_c('ChildrensChoir'),_c('ChildrensResources'),_c('ChildrensStudy'),_c('GetInTouch'),_c('YouthStudy')],1)}
var staticRenderFns = []

export { render, staticRenderFns }